<template>
  <div class="shop-container" v-loading.fullscreen="loading">
    <swiper-small :list="bannerArr" />
    <div class="container bgw">
      <div class="filter-box">
        <!-- <div class="filter-list-wrap">
          <div class="filter-list-head">{{$t('province')}}:</div>
          <div class="filter-list">
            <div
              class="filter-item"
              :class="{active: areaId == ''}"
              @click="clickArea()"
            >{{$t('all')}}</div>
            <div
              class="filter-item"
              :class="{active: areaId == item.value}"
              v-for="item in area"
              :key="item.value"
              @click="clickArea(item)"
            >{{item.label}}</div>
          </div>
        </div> -->

        <div class="filter-list-wrap">
          <div class="filter-list-head">{{$t('type')}}:</div>
          <div class="filter-list">
            <div
              class="filter-item"
              :class="{active: checkId == ''}"
              @click="clickType()"
            >{{$t('all')}}</div>
            <div
              class="filter-item"
              :class="{active: checkId == item.id}"
              v-for="item in arrowType"
              :key="item.id"
              @click="clickType(item)"
            >{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>

    <router-link :to="{name: 'arrowsapply'}" class="ad-wrap">
      <img src="@/assets/images/arrow/ad.jpg" alt />
    </router-link>
    <!-- <div >
            <img src="@/assets/images/arrow/ad.jpg" alt="">
    </div>-->
    <div>
      <div class="reco-arrows" v-if="!checkId && !areaId">
        <!-- 推荐箭馆 -->
        <div class="title">{{$t('recommend')}}{{$t('arrowHall', {text: ""})}}</div>

        <div class="arrow-list">
          <div class="arrow-item" v-for="(item, index) in clubListRec" :key="item.id">
            <div
              class="arrows-pic"
              :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover', height: '257px'}"
            >
              <!-- <img :src="item.cover" alt=""> -->
            </div>
            <div class="arrows-contain">
              <div class="arrow-name">
                <img :src="item.sign" alt />
                {{item.title}}
              </div>
              <div class="arrow-type">{{item.club_type.name}}</div>
              <div class="arrows-about">{{item.desc}}</div>
              <div class="arrows-btn">
                <router-link
                  :to="{name: 'arrowsdetail', query: {id: item.id}}"
                  class="btn01"
                >{{$t('visit')}}</router-link>
                <span
                  class="btn02"
                  @click="collectAction(item, 'clubListRec', index)"
                >{{item.is_collection ? $t('collected') : $t('collection')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="arrows-list">
        <div class="arrow-item" v-for="(item, index) in clubList" :key="item.id">
          <div
            class="pic"
            :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover', height: '257px'}"
          >
            <!-- <img :src="item.cover" alt=""> -->
          </div>
          <div class="content">
            <span class="text">{{$t('area')}}： {{item.area_name || item.address}}</span>
            <span class="text">{{$t('mobile')}}：{{item.phone || ''}}</span>
            <span class="text">{{$t('arrowHall', {text: ''})}}： {{item.title}}</span>
            <span class="text">{{$t('type')}}：{{item.club_type.name || ''}}</span>
          </div>
          <div class="btn">
            <router-link
              :to="{name: 'arrowsdetail', query: {id: item.id}}"
              class="btn btn-01"
            >{{$t('visit')}}</router-link>
            <span
              class="btn btn-02"
              @click="collectAction(item, 'clubList', index)"
            >{{item.is_collection ? $t('collected') : $t('collection')}}</span>
          </div>
        </div>
      </div>
      <div class="pagination-wrap" v-if="totalPage > 0">
        <pagination :totalPage="totalPage" :limit="10" @changePage="changePage" />
      </div>

      <el-dialog
        :title="$t('success', {text: ''})"
        :visible="dialogVisible"
        width="30%"
        center
        :before-close="handleClose"
      >
        <div class="dialog-msg">
          {{dialogMsg}}
          <router-link
            v-if="dialogMsg.indexOf('取消') < 0"
            class="a-link"
            to="/center/arrows"
          >{{$t('seeCollection')}}</router-link>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">{{$t('submit')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import SwiperSmall from "@/components/common/SwiperSmall";
export default {
  components: {
    SwiperSmall,
    Pagination
  },
  data() {
    return {
      bannerArr: [],
      area: [],
      arrowType: [], // 类型
      clubList: [], // 正常的箭馆
      clubListRec: [], // 推荐的箭馆
      dialogVisible: false,
      limit: 9,
      page: 1,
      checkId: "", // 选中的类型id
      areaId: "", // 区域id,
      where: {
        is_rec: 2 //  is_rec 1=推荐 2=不推荐
      },
      totalPage: 0,
      dialogMsg: "",
      token: "",
      loading: false
    };
  },
  created() {
    const _this = this;
    this.token = this.$storage.get("userToken") || "";
    this.getHomeSlider();

    if (localStorage.getItem("areaList")) {
      this.area = JSON.parse(localStorage.getItem("areaList"));
    } else {
      this.$api.getAreaList().then(res => {
        if (res.status) {
          localStorage.setItem("areaList", JSON.stringify(res.data));
          _this.area = res.data;
        }
      });
    }
    // this.area =JSON.parse(localStorage.getItem('areaList'))
    this.list();
    this.club();
    this.clubRec();
  },
  methods: {
    changePage(v) {
      this.page = v;
      this.club();
    },
    // 获取类型
    list() {
      this.$api.getclublist().then(res => {
        if (res.status) {
          this.arrowType = res.data;
        }
      });
    },
    // 箭馆列表 all
    club() {
      this.loading = true;
      let _this = this;
      let form = {
        page: this.page,
        limit: this.limit,
        pc: 1
      };
      if (this.token) {
        form.token = this.token;
      }

      if (this.checkId) {
        form.type_id = this.checkId;
      }

      if (this.areaId) {
        form.area_id = this.areaId;
      }

      this.$api.clublist(form).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status) {
          this.clubList = res.data.list;
          // this.totalPage = Math.ceil(res.data.count / this.limit);
          this.totalPage = res.data.count ? 1 : 0;
        }
      });
    },

    // 设置where参数
    setWhere(params) {
      let copy = JSON.parse(JSON.stringify(this.where));
      copy = { ...copy, ...params };
      return JSON.stringify(copy);
    },
    // 箭馆列表 推荐
    clubRec() {
      let _this = this;
      let form = {
        where: _this.setWhere({
          is_rec: 1
        })
      };
      if (this.token) {
        form.token = this.token;
      }
      this.$api.clublist(form).then(res => {
        if (res.status) {
          this.clubListRec = res.data.list;
        }
      });
    },
    // 类型点击
    clickType(val) {
      this.checkId = val ? val.id : "";
      this.page = 1;
      this.club();
    },
    // 区域点击
    clickArea(val) {
      this.areaId = val ? val.value : "";
      this.page = 1;
      this.club();
    },
    // routerlink点击
    linkLick() {},
    // 分页器点击
    handleCurrentChange() {},
    handleClose() {},
    // 轮播图
    getHomeSlider() {
      let data = {
        code: "pc_arrow_home_slide"
      };
      this.$api.slider(data).then(res => {
        if (res.status) {
          this.bannerArr = res.data.list;
        }
      });
    },
    // 设置收藏
    collectAction(val, target, index) {
      const _this = this;
      this.$api
        .clubcollection({
          club_id: val.id
        })
        .then(res => {
          if (res.msg.indexOf("取消") > -1) {
            this[target][index].is_collection = false;
          } else {
            this[target][index].is_collection = true;
          }
          _this.dialogMsg = res.msg;
          _this.dialogVisible = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.pagination-wrap {
  float: left;
  margin-bottom: 20px;
  width: 100%;
  .page-box {
    float: right;
  }
}
.container {
  background: #fff;
  padding: 4px 18px;
  margin: 20px 0;
  .filter-box {
    margin: 0 auto;
    font-size: 14px;
    .filter-list-wrap {
      position: relative;
      padding-left: 72px;
      transition: height 0.25s linear;
      border-bottom: 1px dashed $border;
      &.open {
        .filter-list {
          height: 120px;
        }
      }
      .filter-list-head {
        width: 72px;
        position: absolute;
        left: 0;
        top: 14px;
        color: #b0b0b0;
      }
      .filter-list {
        display: flex;
        flex-flow: row wrap;
        .filter-item {
          width: 150px;
          height: 20px;
          line-height: 20px;
          padding: 12px 0;
          cursor: pointer;
          &.active {
            color: $theme-color;
          }
        }
      }
      .more {
        position: absolute;
        right: 0;
        top: 8px;
        height: 24px;
        line-height: 24px;
        color: #757575;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: $theme-color;
        }
        .icon {
          display: inline-block;
          transition: all 0.2s;
          &.top {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}

.arrows-list {
  float: left;
  width: 1226px;
  .arrow-item {
    float: left;
    padding: 11px;
    width: 394px;
    margin-right: 20px;
    margin-bottom: 20px;
    background: #fff;
    border: 1px solid #e5e5e5;
    transition: all 0.2s linear 0s;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    .pic {
      width: 362px;
      margin-bottom: 10px;
      img {
        width: 362px;
        height: 257px;
      }
    }
    .content {
      .text {
        width: 100%;
        float: left;
        font-size: 14px;
        padding: 0 5px;
        color: #000;
        line-height: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
    .btn {
      text-align: right;
      font-size: 14px;
      color: #fff;
      padding: 5px 15px;
      cursor: pointer;
      &-01 {
        background: #e7442f;
        border: 1px solid #e7442f;
      }
      &-02 {
        color: #666;
        background: #fff;
        border: 1px solid #ddd;
        margin-left: 10px;
        border: 1px solid #ddd;
      }
    }
  }
}

// 弹窗
.dialog-msg {
  line-height: 100px;
  text-align: center;
}
.ad-wrap {
  img {
    width: 100%;
  }
}

.reco-arrows {
  .title {
    color: #333;
    font-size: 28px;
    text-align: center;
    margin: 20px 0;
    font-weight: 600;
  }
  .arrow-list {
    .arrow-item {
      width: 1226px;
      padding: 20px;
      float: left;
      margin-bottom: 20px;
      border: 1px solid #ddd;
      transition: all 0.2s linear 0s;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
      }
      .arrows-pic {
        float: left;
        width: 380px;
        padding: 5px;
        box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
        img {
          width: 380px;
          height: 270px;
        }
      }
      .arrows-contain {
        width: 718px;
        float: left;
        margin-left: 50px;
        font-size: 14px;
        .arrow-name {
          display: flex;
          align-items: center;
          width: 100%;
          height: 50px;
          float: left;
          color: #333;
          font-size: 22px;
          padding-bottom: 5px;
          margin: 10px 0;
          border-bottom: 1px solid #eee;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border: 1px solid #eee;
          }
        }
        .arrow-type {
          color: #999;
          margin: 2px 0 8px 0;
          width: 100%;
          float: left;
        }
        .arrows-about {
          color: #333;
          height: 125px;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          width: 100%;
          float: left;
          line-height: 24px;
        }
        .arrows-btn {
          text-align: right;
          width: 100%;
          float: left;
          margin-top: 10px;
          .btn01 {
            color: #fff;
            padding: 5px 15px;
            text-align: center;
            background: #e7442f;
            border: 1px solid #e7442f;
          }
          .btn02 {
            padding: 5px 15px;
            text-align: center;
            color: #666;
            background: #fff;
            border: 1px solid #ddd;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.active {
  color: #e7442f !important;
}
.a-link {
  color: #e7442f;
}
</style>